/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

 import { MatDateFormats } from "@angular/material/core";



 export const MAT_MOMENT_DATE_FORMATS: MatDateFormats = {
   parse: {
     dateInput: ['DD-MM-YYYY', 'DD/MM/YYYY', 'll'],

   },
   display: {
     dateInput: 'DD/MM/YYYY',
     dateA11yLabel: 'LL',
     monthYearLabel: 'MMM YYYY',
     monthYearA11yLabel: 'MMM YYYY',
   }
 };